import React, { useState, useRef, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import { ContextApi } from "../../../App";
import { CameraOutlined } from "@ant-design/icons";

function PhotoCapture({ onMoveUp, onMoveDown, onElementDelete, preset }) {
  // States
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "capturephoto",
    properties: {
      label: "Enter label Name",
      placeholder: "Enter here...",
      required: true,
    },
    fillableByCandidate: true,
    fillableByHR: false,
    disableField: false,
  });

  const [modal, setModal] = useState(false);
  const [formError, setFormError] = useState("");
  const contextData = useContext(ContextApi);

  // Refs
  const elementLabelRef = useRef();
  const elementRequiredRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);

  function onEdit() {
    setElement((previousState) => {
      previousState.properties.label = elementLabelRef.current.value;
      previousState.properties.required = elementRequiredRef.current.checked;
      return previousState;
    });
    setFormError("");
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit: !contextData.contextData.isEdit,
    });
  }

  return (
    <div
      className="form-group form-builder-element mb-3"
      data={JSON.stringify(element)}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e, element)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>
      <label>
        {element.properties.label}
        {element.properties.required && <span style={{ color: "red" }}>*</span>}
      </label>
      <div>
        <CameraOutlined style={{ fontSize: "2rem" }} />
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Capture Photo Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Label</label>
            <input
              ref={elementLabelRef}
              defaultValue={element.properties.label}
              type="text"
              className="form-control"
            />
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default PhotoCapture;
